var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -692.31 640 442.31",
    width: 20,
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M641.69-327.69 619.15-351l159-159-159-159 22.54-23.31L824-510zM184-250v-104q0-71.54 50.23-121.77T356-526h249.54l-143-143 22.54-23.31L667.38-510l-182.3 182.31L462.54-351l143-143H356q-57.69 0-98.85 41.15Q216-411.69 216-354v104z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.5e80e7c1d3295e7fd077fd0e0f0cde3b.svg";
export { ForwardRef as ReactComponent };